import { Button } from '@avanta/shared/components/ui/Button';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { PageHeader } from 'components/PageHeader';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';
import { RecentActivity } from './components/RecentActivity';
import { RecentSessions } from './components/RecentSessions';

export const Home = (): ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);

  const userName = user?.name ?? '';
  const title = t('HomePage.heading', { name: userName });
  const description = t('HomePage.description');

  return (
    <div className="flex flex-col gap-8">
      <PageHeader title={title} description={description}>
        <Button
          type="button"
          variant="primary"
          size="md"
          onClick={() =>
            navigate(ROUTES.APPOINTMENTS_RESERVE, { state: { flow: FLOW_MODES.search_patient } })
          }
        >
          {t('HomePage.scheduleSession.cta')}
        </Button>
      </PageHeader>
      <div className="flex flex-col gap-6 am-lg:flex-row">
        <div className="min-w-0 flex-1">
          <RecentSessions />
        </div>
        <div className="w-full max-w-72 shrink-0">
          <RecentActivity />
        </div>
      </div>
    </div>
  );
};
